const colors = {
    azul: '#003686',
    naranja: '#E08400',
    negro: 'black',
    blanco: 'white'
};

export default colors;

